import * as React from "react";

const AppStore: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 125 30"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <g fill="none" fillRule="evenodd">
                <rect width="125" height="30" fill="currentColor" rx="6" />
                <text fill="#00609C" fontFamily="Montserrat-SemiBold, Montserrat" fontSize="12" fontWeight="500">
                    <tspan x="38" y="19">
                        APP STORE
                    </tspan>
                </text>
                <path
                    fill="#00609C"
                    d="M28.171 16.485h2.766c.59 0 1.063.473 1.063 1.062 0 .59-.473 1.062-1.063 1.062h-1.536l1.037 1.797a1.064 1.064 0 11-1.846 1.061c-1.747-3.025-3.058-5.288-3.928-6.796-.89-1.535-.254-3.075.374-3.597.698 1.196 1.74 3.002 3.133 5.411zm-8.802 3.212l-1.022 1.77a1.065 1.065 0 01-1.846-1.061l.76-1.313c.858-.266 1.556-.061 2.108.604zm4.1-11.345l.473-.816a1.065 1.065 0 011.846 1.061L21.23 16.48h3.298c1.068 0 1.667 1.255 1.203 2.124h-9.667c-.59 0-1.063-.473-1.063-1.062 0-.59.473-1.062 1.063-1.062h2.71l3.47-6.006-1.084-1.879a1.064 1.064 0 111.846-1.061l.464.82z"
                />
            </g>
        </svg>
    );
};

export default React.memo(AppStore);
